import * as Yup from "yup";

export const chemoProtocolSchema = Yup.object().shape({
    // chemo_regimen_details: Yup.string()
    //     .required("Chemotherapy regimen details are required"),

    // treatment_intent: Yup.string()
    //     .required("Treatment intent is required"),

    // vascular_access: Yup.string()
    //     .required("Vascular access is required"),

    // known_drug_allergies: Yup.string()
    //     .required("Known drug allergies is required"),

    // significant_adverse_reactions_reported: Yup.string()
    //     .required("Significant adverse reactions is required"),


    // chemo_dosage: Yup.array()
    //     .of(
    //         Yup.object().shape({
    //             chemo_administered_date: Yup.string().required("Date is required"),
    //             chemo_dosage: Yup.string()
    //                 .required("Dose is required")
    //                 .trim(),
    //         })
    //     )
    //     .min(1, "At least one treatment entry is required"),
});
